<template>
    <v-row no-gutters>
        <v-col cols="auto">
            <v-btn icon tile width="40" min-height="40" height="100%" class="handle" style="cursor: grab">
                <v-icon>mdi-drag</v-icon>
            </v-btn>
        </v-col>
        <v-divider vertical />
        <v-col cols="4">
            <v-combobox v-model="form.type" :items="types" solo flat dense hide-details @input="emit" />
        </v-col>
        <v-divider vertical />
        <v-col>
            <tags-data v-model="form" @input="emit" />
        </v-col>
        <v-divider vertical />
        <v-col cols="auto">
            <v-btn icon tile width="40" min-height="40" height="100%" color="red" @click="$emit('pull', form)">
                <v-icon>mdi-minus</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12" v-if="showsDivider">
            <v-divider />
        </v-col>
    </v-row>
</template>

<script>
import { initCommonMetatag_Tag, COMMON_METATAG_TAG_TYPES } from "@/store/metatags";

import TagsData from "./tags-data.vue";

const types = Object.keys(COMMON_METATAG_TAG_TYPES);

export default {
    components: {
        TagsData,
    },
    props: {
        value: { type: Object, default: initCommonMetatag_Tag },
        showsDivider: { type: Boolean, default: false },
    },
    data: () => ({
        types,
        form: initCommonMetatag_Tag(),
    }),
    methods: {
        sync() {
            this.form = initCommonMetatag_Tag(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
